export default __webpack_public_path__ + "static/media/naval_envelopment.5da6d341.png";